export enum CommonMessage {
  NO_DATA = 'No data available',
  PERMISSION_DENIED = 'Permission denied'
}
